import { isPromise } from "./_internal/utils.js";
function delay(wait, value) {
    return new Promise((resolve, reject) => {
        if (isPromise(value)) {
            value.catch(reject);
        }
        setTimeout(() => {
            resolve(value);
        }, wait);
    });
}
export default delay;
//# sourceMappingURL=delay.js.map